import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class Settings extends Component {

  state = {

    user_id: localStorage.getItem("user_id"),
    user_role: localStorage.getItem("user_role"),

    theme_or_landing_status: "",
    inside_delivery_area_charge: "",
    outside_delivery_area_charge: "",
    currency_symbol: "",
    powered_by: "",
    courier_api_key: "",

    loading: false,
  };

  API_BASE = axios.defaults.baseURL;
  PUBLIC_BASE = this.API_BASE.replace("/api", "");

  componentDidMount() {
    this.fetchExistingData();
  }

  fetchExistingData = async () => {
    const { user_id, user_role } = this.state;

    if (!user_id || !user_role) return;

    try {
      this.setState({ loading: true });

      const res = await axios.get("/settings", {
        params: { user_id, user_role },
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      const d = res?.data?.data;
      if (d) {
        this.setState({
          theme_or_landing_status: d.theme_or_landing_status || "",
          inside_delivery_area_charge: d.inside_delivery_area_charge || "",
          outside_delivery_area_charge: d.outside_delivery_area_charge || "",
          currency_symbol: d.currency_symbol || "",
          powered_by: d.powered_by || "",
          courier_api_key: d.courier_api_key || "",
        });
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };


  handleSubmit = async (e) => {
    e.preventDefault();

    const { user_id, user_role } = this.state;

    if (!user_id || !user_role) {
      Swal.fire("Error", "User ID or role missing", "error");
      return;
    }

    try {
      this.setState({ loading: true });

      let formData = new FormData();

      formData.append("user_id", user_id);
      formData.append("user_role", user_role);

      [
        "theme_or_landing_status",
        "inside_delivery_area_charge",
        "outside_delivery_area_charge",
        "currency_symbol",
        "powered_by",
        "courier_api_key",
      ].forEach((k) => formData.append(k, this.state[k]));

      const res = await axios.post("/settings", formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire("Success", res.data.message, "success");

      this.fetchExistingData();
    } catch (error) {
      console.error(error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      theme_or_landing_status,
      inside_delivery_area_charge,
      outside_delivery_area_charge,
      currency_symbol,
      powered_by,
      courier_api_key,
      loading,
    } = this.state;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm border-0 rounded-4">

                <div className="card-header">
                  <h4 className="mb-0">Settings</h4>
                </div>

                <div className="card-body p-4">
                  <form onSubmit={this.handleSubmit}>
                    <div className="row g-3">


                      <div className="col-md-6">
                        <label className="form-label">
                          Select Theme or Landing Status <span className="text-danger">*</span>
                        </label>
                        <select
                          name="theme_or_landing_status"
                          className="form-control"
                          value={theme_or_landing_status}
                          onChange={this.handleChange}
                          required>
                          <option value="">Select</option>
                          <option value="0">Theme</option>
                          <option value="1">Landing</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Currency Symbol</label>
                        <input
                          type="text"
                          name="currency_symbol"
                          className="form-control"
                          value={currency_symbol}
                          onChange={this.handleChange}
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Inside Delivery Area Charged</label>
                        <input
                          type="text"
                          name="inside_delivery_area_charge"
                          className="form-control"
                          value={inside_delivery_area_charge}
                          onChange={this.handleChange}
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Outside Delivery Area Charged</label>
                        <input
                          type="text"
                          name="outside_delivery_area_charge"
                          className="form-control"
                          value={outside_delivery_area_charge}
                          onChange={this.handleChange}
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Froud Courier Checker ( https://bdcourier.com/ )</label>
                        <input
                          type="text"
                          name="courier_api_key"
                          className="form-control"
                          value={courier_api_key}
                          onChange={this.handleChange}
                          Placeholder="Courier API Key"
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Powered By</label>
                        <input
                          type="text"
                          name="powered_by"
                          className="form-control"
                          value={powered_by}
                          onChange={this.handleChange}
                        />
                      </div>


                    </div>

                    <div className="text-end mt-4">
                      <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Settings;
